import React from 'react';
import { useParallax } from '../hooks/useParallax';
export function AboutHost() {
  const {
    ref,
    style
  } = useParallax(0.2);
  return <section className="bg-eofa-black py-20 md:py-32 overflow-hidden" data-id="element-12">
      <div className="container mx-auto px-6" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-14">
          {/* Text Content */}
          <div className="order-1" data-id="element-15">
            <span className="text-eofa-yellow tracking-[0.2em] text-[13px] uppercase font-bold mb-4 block" data-id="element-16">
              YOUR HOSTS
            </span>
            <h2 className="text-eofa-white font-heading font-black text-[32px] md:text-[48px] leading-[1.1] tracking-tighter mb-6" data-id="element-17">
              Built by entrepreneurs, for entrepreneurs.
            </h2>
            <p className="text-eofa-body text-base md:text-lg leading-relaxed mb-8" data-id="element-18">
              Hosted by Josh and Noah, the founders of LetLois, the EofA Podcast
              was born from one simple idea. The best business lessons don't
              come from billionaires on stages. They come from the everyday
              operators in your own backyard. Every week we sit down with
              Arizona business owners doing the work, sharing what's actually
              moving the needle in their world. No theory. No fluff. Just real
              conversations with real builders.
            </p>
            <button className="bg-eofa-yellow text-eofa-black font-bold rounded-md px-8 min-h-[48px] hover:bg-yellow-400 transition-colors" data-id="element-19">
              Be a Guest on the Show
            </button>
          </div>

          {/* Portrait Image */}
          <div className="order-2 lg:order-2" data-id="element-20">
            <div ref={ref} className="relative overflow-hidden rounded-lg flex items-end justify-center bg-eofa-dark" data-id="element-21">
              <img src="https://cdn.magicpatterns.com/uploads/x2UFBpN5d3MNFgMfdxDKvb/LetLois_People.png" alt="Josh and Noah, Hosts of EofA Podcast" className="w-full h-auto object-contain" style={style} data-id="element-22" />
              <div className="absolute inset-0 bg-gradient-to-t from-eofa-black/30 to-transparent" data-id="element-23" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}